import { CheckIcon, DeleteIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import Select from "../../../shared/components/Select";
import {
  Certification,
  CertificationBroadcastSetting,
  ViewProps,
} from "../certification-broadcast-settings.types";

const isSameCertifications = (a: Certification[], b: Certification[]) => {
  if (a.length !== b.length) {
    return false;
  }

  const sortedA = [...a].sort();
  const sortedB = [...b].sort();

  return sortedA.every((value, index) => value === sortedB[index]);
};

export default function SettingRow(
  props: ViewProps & {
    setting: CertificationBroadcastSetting;
  }
) {
  const key = String(props.setting.id);
  const permitted = props.draftPermitted[key] ?? props.setting.permittedCertifications;
  const isDirty = !isSameCertifications(
    permitted ?? [],
    props.setting.permittedCertifications ?? []
  );

  return (
    <tr>
      <td>{props.setting.id}</td>
      <td>{props.officeNameMap.get(props.setting.officeId) ?? String(props.setting.officeId)}</td>
      <td>
        <Select
          isDisabled
          buttonProps={{ width: "100%" }}
          label="Certification"
          multiple={false}
          options={props.certificationOptions}
          size="sm"
          value={props.setting.primaryCertification}
          width="220px"
          onChange={() => undefined}
        />
      </td>
      <td>
        <Select
          searchable
          buttonProps={{ width: "100%" }}
          isDisabled={props.certificationOptions.length === 0}
          label="Permitted"
          multiple={true}
          options={props.certificationOptions}
          size="sm"
          value={permitted.length > 0 ? permitted : null}
          width="320px"
          onChange={(value) => props.onChangeDraftPermitted(props.setting.id, value)}
        />
      </td>
      <td>
        <Flex gap={2}>
          <Button
            colorScheme="blue"
            isDisabled={!isDirty || props.updateLoading}
            isLoading={props.updateLoading}
            leftIcon={<CheckIcon />}
            size="sm"
            onClick={() => props.onUpdate(props.setting, permitted)}
          >
            Save
          </Button>
          <Button
            colorScheme="red"
            isDisabled={props.deleteLoading}
            leftIcon={<DeleteIcon />}
            size="sm"
            variant="outline"
            onClick={() => {
              if (!window.confirm("Delete this setting?")) {
                return;
              }

              props.onDelete(props.setting);
            }}
          >
            Delete
          </Button>
        </Flex>
      </td>
    </tr>
  );
}
